import { render, staticRenderFns } from "./ProjectUserPledge.vue?vue&type=template&id=4bc99790"
import script from "./ProjectUserPledge.vue?vue&type=script&lang=js"
export * from "./ProjectUserPledge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports